export default "__VITE_PUBLIC_ASSET__01346fa4__"